import React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { FP } from "./tokens";

/**
 * Tarjeta de acción grande para la operación principal de una pantalla
 * (registrar una venta, abrir un conteo, etc.): más visible y fácil de
 * tocar que un botón en la cabecera, sobre todo en pantallas táctiles.
 */
export default function ActionCard({ icon: Icon, titulo, descripcion, color, onClick }) {
  return (
    <Card
      elevation={0}
      onClick={onClick}
      sx={{
        borderRadius: 2.5,
        border: `2px solid ${color}55`,
        boxShadow: FP.shadow.soft,
        cursor: "pointer",
        transition: "all .15s ease",
        "&:hover": { borderColor: color, bgcolor: `${color}0A`, transform: "translateY(-2px)" },
      }}
    >
      <CardContent sx={{ display: "flex", alignItems: "center", gap: 2, p: { xs: 2, md: 2.6 }, "&:last-child": { pb: { xs: 2, md: 2.6 } } }}>
        <Box
          sx={{
            width: 54,
            height: 54,
            borderRadius: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: `${color}14`,
            color,
            flexShrink: 0,
          }}
        >
          <Icon sx={{ fontSize: 30 }} />
        </Box>
        <Box sx={{ minWidth: 0 }}>
          <Typography sx={{ fontWeight: 800, fontSize: "1.02rem", color: FP.color.textPrimary }}>{titulo}</Typography>
          <Typography sx={{ fontSize: "0.8rem", color: FP.color.textSecondary }}>{descripcion}</Typography>
        </Box>
        <Box sx={{ flex: 1 }} />
        <AddCircleOutlineIcon sx={{ color, fontSize: 28, flexShrink: 0 }} />
      </CardContent>
    </Card>
  );
}
